export default (preview: string) => {
  const strSize = preview.match(/_(\d+)\.([a-z]{1,4})/)?.[1];

  return strSize ? parseInt(strSize, 10) : null;
};
